import { async } from 'regenerator-runtime';
import recipeView from './views/recipeView.js';
import { API_URL, KEY, RESULTS_PER_PAGE } from './config.js';
import { getJSON, sendJSON } from './helpers.js';
// import { API_URL, RES_PER_PAGE, KEY } from './config.js';
// import { getJSON, sendJSON } from './helpers.js';

// if (module.hot) {
//   module.hot.accept();
// }

export const state = {
  recipe: {},
  search: {
    query: '',
    results: [],
    page: 1,
    resultsPerPage: RESULTS_PER_PAGE,
  },
  bookmarks: [],
};
function createRecipeObject(data) {
  let { recipe } = data.data;
  return {
    id: recipe.id,
    title: recipe.title,
    sourceUrl: recipe.source_url,
    imageUrl: recipe.image_url,
    publisher: recipe.publisher,
    cookingTime: +recipe.cooking_time,
    servings: +recipe.servings,
    ingredients: recipe.ingredients,
    ...(recipe.key && { key: recipe.key }),
  };
}
export const loadRecipe = async function (id) {
  try {
    const data = await getJSON(`${API_URL}${id}?key=${KEY}`);

    state.recipe = createRecipeObject(data);
    // console.log(state.recipe);
    if (state.bookmarks.some(v => v.id === id)) state.recipe.bookmarked = true;
    else state.recipe.bookmarked = false;
  } catch (err) {
    console.error(err + '😭😭');
    throw err;
  }
};
export async function loadSearchResults(searchQuery) {
  try {
    state.search.query = searchQuery;
    const data = await getJSON(`${API_URL}?search=${searchQuery}&key=${KEY}`);

    state.search.results = data.data.recipes.map(el => {
      return {
        id: el.id,
        title: el.title,
        imageUrl: el.image_url,
        publisher: el.publisher,
        ...(el.key && { key: el.key }),
      };
    });
    // console.log(state.search.results);
    state.search.page = 1;
  } catch (err) {
    console.error(err + '😭😭');
    throw err;
  }
}
// loadSearchResults('pizza');

export const getSearchResultsPage = function (page = state.search.page) {
  state.search.page = page;
  let start = (page - 1) * state.search.resultsPerPage;
  let end = page * state.search.resultsPerPage;
  return state.search.results.slice(start, end);
};

export const updateServings = function (newServings) {
  state.recipe.ingredients.forEach(element => {
    element.quantity = element.quantity * (newServings / state.recipe.servings);
  });
  state.recipe.servings = newServings;
};

export const addBookmark = function (recipe) {
  //Add bookmark
  state.bookmarks.push(recipe);

  // Mark current recipe as bookmark
  if (recipe.id === state.recipe.id) state.recipe.bookmarked = true;
  persistBookmark();
};

export function deleteBookmark(id) {
  // Delete Bookmark
  let index = state.bookmarks.findIndex(v => v.id === id);
  state.bookmarks.splice(index, 1);

  // Mark current recipe unbookmarked
  if (id === state.recipe.id) state.recipe.bookmarked = false;
  persistBookmark();
}

export function persistBookmark() {
  localStorage.setItem('bookmarks', JSON.stringify(state.bookmarks));
}

const init = function () {
  const storage = localStorage.getItem('bookmarks');
  if (storage) state.bookmarks = JSON.parse(storage);
};
init();
console.log(state.bookmarks);
/**
 * read function name
 * @param {just have fun lol | Object[]} newRecipe
 */
export const uploadRecipe = async function (newRecipe) {
  try {
    const ingredients = Object.entries(newRecipe)
      .filter(value => value[0].startsWith('ingredient') && value[1] !== '')
      .map(ing => {
        let ingArr = ing[1].replaceAll(' ', '').split(',');
        if (ingArr.length !== 3) {
          throw new Error(
            'Wrong Ingredient Format! Please follow the format and try again!!'
          );
        }
        let [quantity, unit, description] = ingArr;
        return { quantity: quantity ? +quantity : null, unit, description };
      });

    const recipe = {
      title: newRecipe.title,
      source_url: newRecipe.sourceUrl,
      image_url: newRecipe.image,
      publisher: newRecipe.publisher,
      cooking_time: +newRecipe.cookingTime,
      servings: +newRecipe.servings,
      ingredients,
    };

    const data = await sendJSON(`${API_URL}?key=${KEY}`, recipe);
    // console.log(data);
    state.recipe = createRecipeObject(data);
    addBookmark(state.recipe);
  } catch (err) {
    throw err;
  }
};
